export const quotaQueryKeys = {
  all: ['admin-quota'] as const,
  detail: (userId: string) => [...quotaQueryKeys.all, 'detail', userId] as const,
  events: (userId: string, page: number, pageSize: number) =>
    [...quotaQueryKeys.all, 'events', userId, page, pageSize] as const,
  periods: (userId: string, page: number, pageSize: number) =>
    [...quotaQueryKeys.all, 'periods', userId, page, pageSize] as const,
};

export const currentQuotaQueryKey = ['quota', 'me'] as const;
